import type {TTSHookProps} from "tts-react";
import {useTts} from "tts-react";
import {useState} from "react";


interface CustomProps extends TTSHookProps {
    highlight?: boolean
}

const CustomTTSComponent = ({ children, highlight = false, isTalkingInput}: CustomProps) => {

    const [isPaused, setIsPaused] = useState(false);

    const { ttsChildren, state, play, stop, pause } = useTts({
        children,
        markTextAsSpoken: highlight,
        markBackgroundColor: "#05A826",
        markColor: "white",
        lang: "en-US",
    })

    const handlePlayOnClick = () => {
        play().then(r => r)
        isTalkingInput.value = true
        setIsPaused(false)
    }

    const handlePauseOnClick = () => {
        pause()
        isTalkingInput.value = false
        setIsPaused(true)
    }

    const handleStopOnClick = () => {
        stop()
        isTalkingInput.value = false
        setIsPaused(false)

    }

    return (
        <div className="playable-message">
            {ttsChildren}
            <div className="buttons-section">
                <div onClick={handlePlayOnClick} className={`playable-button ${ state.isPlaying ? `is-playing` : `` }`}>
                    <p>Play</p>
                </div>
                <div onClick={handlePauseOnClick} className={`playable-button ${ state.isPlaying ? `` : `is-disabled` }`}>
                    <p>Pause</p>
                </div>
                <div onClick={handleStopOnClick} className={`playable-button ${ state.isPlaying ? `` : isPaused ? `` : `is-disabled` }`}>
                    <p>Stop</p>
                </div >
            </div>
        </div>
    )
}

export default CustomTTSComponent